import {
  Box,
  Chip,
  Grid,
  IconButton,
  TablePagination,
} from "@material-ui/core";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { Autocomplete } from "@material-ui/lab";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import {
  Business as BusinessIcon,
  DirectionsCar as CarIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  Person as PersonIcon,
  Phone as PhoneIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@material-ui/icons";
import { DeleteFileAction } from "../../actions/DeleteFile";
import { VehicleAction } from "../../actions/vehicle";
import { VendorAction } from "../../actions/vendor";
import { NitMasterAction } from "../../actions/NitMaster";
import useCommonStyles from "../CommonComponents/CommanStyle/indexStyle";
import AlertDialog from "../CommonComponents/confirmDialog";
import LoadingComponent from "../CommonComponents/loadinComponent";
import { useSnackbar } from "../CommonComponents/SnackbarProvider";
import TopView from "../CommonComponents/topView";
import { useMemo } from "react";
import moment from "moment"; // assuming you're okay using moment.js
const useLocalStyles = makeStyles((theme) => ({
  statusChip: {
    borderRadius: 20,
    fontWeight: 600,
    textTransform: "uppercase",
    fontSize: "0.75rem",
    letterSpacing: "0.05em",
    background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    color: "white",
    margin: "2px",
  },
  activeChip: {
    background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    color: "white",
  },
  inactiveChip: {
    background: "linear-gradient(135deg, #6b7280 0%, #4b5563 100%)",
    color: "white",
  },

  tableContainer: {
    borderRadius: 16,
    overflow: "hidden",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.08)",
    background: "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(102, 126, 234, 0.1)",
    marginTop: theme.spacing(2),
  },
  tableHead: {
    background: "linear-gradient(135deg, #0f3460 0%, #23467eff 100%)",
    "& .MuiTableCell-head": {
      color: "white",
      fontWeight: 600,
      fontSize: "0.95rem",
      letterSpacing: "0.02em",
      borderBottom: "none",
    },
  },
  tableRow: {
    transition: "all 0.3s ease",
    background: "rgba(255, 255, 255, 0.8)",
    "&:nth-of-type(even)": {
      background: "rgba(248, 250, 252, 0.8)",
    },
    "&:hover": {
      background: "rgba(102, 126, 234, 0.05)",
      transform: "scale(1.01)",
      boxShadow: "0 4px 12px rgba(102, 126, 234, 0.1)",
    },
  },
  actionButton: {
    borderRadius: 12,
    margin: theme.spacing(0, 0.5),
    padding: 8,
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.1)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    },
  },
  editButton: {
    color: "#667eea",
    background: "rgba(102, 126, 234, 0.1)",
    "&:hover": {
      background: "rgba(102, 126, 234, 0.2)",
    },
  },
  deleteButton: {
    color: "#ef4444",
    background: "rgba(239, 68, 68, 0.1)",
    "&:hover": {
      background: "rgba(239, 68, 68, 0.2)",
    },
  },
  outlinedChip: {
    margin: "2px 4px",
    borderColor: "#667eea",
    color: "#667eea",
    fontSize: "0.75rem",
    fontWeight: 500,
    borderRadius: 20,
    transition: "all 0.3s ease",
    "&:hover": {
      background: "rgba(102, 126, 234, 0.1)",
      transform: "scale(1.05)",
    },
  },
  sectionTitle: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: 600,
    fontSize: "1.25rem",
  },

  transactionChip: {
    borderRadius: 20,
    fontWeight: 600,
    textTransform: "uppercase",
    fontSize: "0.75rem",
    letterSpacing: "0.05em",
    margin: "2px",
  },
  transactionActiveChip: {
    background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    color: "white",
    boxShadow: "0 4px 12px rgba(16, 185, 129, 0.3)",
  },
  transactionInactiveChip: {
    background: "linear-gradient(135deg, #6b7280 0%, #4b5563 100%)",
    color: "white",
    boxShadow: "0 4px 12px rgba(107, 114, 128, 0.3)",
  },

  pagination: {
    background: "rgba(248, 250, 252, 0.8)",
    borderTop: "1px solid rgba(102, 126, 234, 0.1)",
    "& .MuiTablePagination-toolbar": {
      minHeight: "60px",
    },
    "& .MuiTablePagination-selectRoot": {
      borderRadius: 8,
    },
  },

  emptyState: {
    padding: theme.spacing(4),
    textAlign: "center",
    background:
      "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
    borderRadius: 12,
    margin: theme.spacing(2),
  },

  sectionContainer: {
    background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
    border: "1px solid rgba(102, 126, 234, 0.2)",
    borderRadius: "20px",
    padding: theme.spacing(3),
    margin: theme.spacing(3, 0),
    backdropFilter: "blur(10px)",
  },
  transactionModal: {
    "& .MuiDialog-paper": {
      borderRadius: 20,
      background: "rgba(255, 255, 255, 0.98)",
      backdropFilter: "blur(20px)",
      boxShadow: "0 20px 40px rgba(0, 0, 0, 0.2)",
      border: "1px solid rgba(102, 126, 234, 0.2)",
    },
  },
  modalTitle: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: 700,
    fontSize: "1.5rem",
    padding: theme.spacing(3),
    borderBottom: "1px solid rgba(102, 126, 234, 0.1)",
  },
  modalContent: {
    padding: theme.spacing(3),
    backgroundColor: "white",
  },

  addButton: {
    backgroundColor: "#003a6b",
    padding: "2px 10px",
    color: "white",
  },
}));

const validateVendorData = (formData) => {
  let errors = {};

  // Name validation
  if (!formData.name || formData.name.trim() === "") {
    errors.name = "Name is required";
  } else if (formData.name.trim().length < 3) {
    errors.name = "Name must be at least 3 characters";
  } else if (!/^[a-zA-Z0-9\s@%&_\-,\.\(\)]+$/.test(formData.name.trim())) {
    errors.name = "Name can only contain letters, numbers, spaces, and @ % & _ - , . ( )";
  } else if (/^\d+$/.test(formData.name.trim())) {
    errors.name = "Name cannot be numbers only";
  }

  // Official name validation
  if (!formData.officialName || formData.officialName.trim() === "") {
    errors.officialName = "Official name is required";
  } else if (formData.officialName.trim().length < 3) {
    errors.officialName = "Official name must be at least 3 characters";
  } else if (!/^[a-zA-Z0-9\s@%&_\-,\.\(\)]+$/.test(formData.officialName.trim())) {
    errors.officialName = "Official name can only contain letters, numbers, spaces, and @ % & _ - , . ( )";
  } else if (/^\d+$/.test(formData.officialName.trim())) {
    errors.officialName = "Official name cannot be numbers only";
  }

  // Email validation
  if (!formData.email || formData.email.trim() === "") {
    errors.email = "Email is required";
  } else if (!/^[a-zA-Z0-9\s@%&_\-,\.\(\)]+$/.test(formData.email.trim())) {
    errors.email = "Email can only contain letters, numbers, spaces, and @ % & _ - , . ( )";
  } else if (
    !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email.trim())
  ) {
    errors.email = "Please enter a valid email address";
  }

  // Mobile number validation
  if (!formData.vendorMobile || formData.vendorMobile.trim() === "") {
    errors.vendorMobile = "Mobile number is required";
  } else if (!/^\d{10}$/.test(formData.vendorMobile.trim())) {
    errors.vendorMobile = "Mobile number must be exactly 10 digits";
  } 

  // Company name validation
  if (!formData.companyName || formData.companyName.trim() === "") {
    errors.companyName = "Company name is required";
  } else if (formData.companyName.trim().length < 3) {
    errors.companyName = "Company name must be at least 3 characters";
  } else if (!/^[a-zA-Z0-9\s@%&_\-,\.\(\)]+$/.test(formData.companyName.trim())) {
    errors.companyName = "Company name can only contain letters, numbers, spaces, and @ % & _ - , . ( )";
  } else if (/^\d+$/.test(formData.companyName.trim())) {
    errors.companyName = "Company name cannot be numbers only";
  }

  // Address validation
  if (!formData.address || formData.address.trim() === "") {
    errors.address = "Address is required";
  } else if (formData.address.trim().length < 10) {
    errors.address = "Address must be at least 10 characters";
  } else if (!/^[a-zA-Z0-9\s@%&_\-,\.\(\)]+$/.test(formData.address.trim())) {
    errors.address = "Address can only contain letters, numbers, spaces, and @ % & _ - , . ( )";
  } else if (/^\d+$/.test(formData.address.trim())) {
    errors.address = "Address cannot be numbers only";
  }

  if (formData.value !== "Existing") {
    if (
      formData.vehicleNumber ||
      formData.vehicleTypeValue ||
      formData.chassisNumber ||
      formData.engineNumber ||
      formData.weightLimit
    ) {
      if (!formData.vehicleNumber || formData.vehicleNumber.trim() === "") {
        errors.vehicleNumber = "Vehicle number is required";
      }

      if (!formData.vehicleTypeValue) {
        errors.vehicleTypeValue = "Vehicle type is required";
      }

      if (!formData.chassisNumber || formData.chassisNumber.trim() === "") {
        errors.chassisNumber = "Chassis number is required";
      }

      if (!formData.engineNumber || formData.engineNumber.trim() === "") {
        errors.engineNumber = "Engine number is required";
      }

      if (!formData.weightLimit || formData.weightLimit.trim() === "") {
        errors.weightLimit = "Weight limit is required";
      }
    }
  }

  return errors;
};

const validateTransactionData = (transaction) => {
  const errors = {};

  if (!transaction.fromDate) {
    errors.fromDate = "From Date is required";
  }

  if (!transaction.toDate) {
    errors.toDate = "To Date is required";
  }

  if (transaction.fromDate && transaction.toDate) {
    if (new Date(transaction.fromDate) > new Date(transaction.toDate)) {
      errors.toDate = "To Date cannot be before From Date";
    }
  }

  return errors;
};

export default function VendorForm() {
  const { showSnackbar } = useSnackbar();
  const classes = useCommonStyles();
  const localStyles = useLocalStyles();
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = Boolean(id);

  const [designationList, setDesignationList] = React.useState([]);
  const [name, setName] = React.useState("");
  const [officialName, setOfficialName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [companyName, setCompanyName] = React.useState("");
  const [vendorMobile, setVendorMobile] = React.useState("");
  const [vehicleTypeList, setVehicleTypeList] = React.useState([]);
  const [vehicleTypeValue, setVehicleTypeValue] = React.useState("");
  const [vehicleNumber, setVehicleNumber] = React.useState("");
  const [engineNumber, setEngineNumber] = React.useState("");
  const [weightLimit, setWeightLimit] = React.useState("");
  const [chassisNumber, setChassisNumber] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [file, setFile] = React.useState(null);
  const [fileView, setFileView] = React.useState("");
  const [value, setValue] = React.useState("Existing");
  const [vehicleList, setVehicleList] = React.useState([]);
  const [multiVehicles, setMultiVehicles] = React.useState([]);
  const [isLoading, setLoading] = React.useState(false);
  const [openAlert, setOpen] = React.useState(false);
  const [errors, setErrors] = React.useState({});
  const [permissionAccess, setPermissionAccess] = React.useState(
    JSON.parse(sessionStorage.getItem("data")),
  );
  const [transactionModalOpen, setTransactionModalOpen] = React.useState(false);
  const [transactions, setTransactions] = React.useState([]);
  const [newTransaction, setNewTransaction] = React.useState({
    fromDate: null,
    toDate: null,
    isActive: true,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [editingTransactionId, setEditingTransactionId] = useState(null);
  const [transactionErrors, setTransactionErrors] = React.useState({});

  // Generate temporary IDs for transactions in create mode
  const [tempTransactionId, setTempTransactionId] = useState(1);
  const [nitList, setNitList] = React.useState([]);
  const [selectedNit, setSelectedNit] = React.useState(null);

  const formattedTransactions = useMemo(() => {
    return transactions.map((t) => ({
      ...t,
      fromDateFormatted: t.fromDate
        ? moment(t.fromDate).format("DD MMM YYYY")
        : "",
      toDateFormatted: t.toDate ? moment(t.toDate).format("DD MMM YYYY") : "",
    }));
  }, [transactions]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEditTransaction = (transaction) => {
    setNewTransaction({
      ...transaction,
      fromDate: new Date(transaction.fromDate),
      toDate: new Date(transaction.toDate),
    });
    setEditingTransactionId(transaction.id);
    setTransactionModalOpen(true);
  };

  const handleDeleteTransaction = (transactionId) => {
    setTransactions(transactions.filter((t) => t.id !== transactionId));
    showSnackbar("Transaction removed successfully", "success");
  };

  const handleSaveTransaction = () => {
    const validationErrors = validateTransactionData(newTransaction);
    setTransactionErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      showSnackbar("Please fix the validation errors", "error");
      return;
    }

    if (!isEditMode) {
      showSnackbar(
        "Transactions can only be added after Transporter creation",
        "error",
      );
      return;
    }

    setLoading(true);
    const userData = JSON.parse(sessionStorage.getItem("data"));

    const transactionData = {
      vendorId: id,
      fromTransactionDate: newTransaction.fromDate.toISOString().split("T")[0],
      toTransactionDate: newTransaction.toDate.toISOString().split("T")[0],
      isActive: newTransaction.isActive,
    };

    VendorAction.addTransaction(transactionData, showSnackbar).then(
      (response) => {
        if (response != null) {
          if (response.responseCode !== 200) {
            showSnackbar(response.message, "error");
          } else {
            showSnackbar("Transaction added successfully", "success");
            setTransactionModalOpen(false);
            setEditingTransactionId(null);
            setNewTransaction({
              fromDate: null,
              toDate: null,
              isActive: true,
            });
            setTransactionErrors({});
            fetchById();
          }
        }
        setLoading(false);
      },
    );
  };

  const vehicleManagement = permissionAccess?.menuVisiblity?.find(
    (menu) => menu.name === "TRANSPORTER_MANAGEMENT",
  );

  const updateUserPermission = vehicleManagement?.addPermission || false;

  const handleChange = (fieldName, value) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: "",
    }));

    switch (fieldName) {
      case "name":
        setName(value);
        if (value.trim().length > 0 && value.trim().length < 3) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: "Name must be at least 3 characters",
          }));
        } else if (value.trim().length >= 3) {
          if (!/^[a-zA-Z0-9\s@%&_\-,\.\(\)]+$/.test(value.trim())) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [fieldName]: "Name can only contain letters, numbers, spaces, and @ % & _ - , . ( )",
            }));
          } else if (/^\d+$/.test(value.trim())) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [fieldName]: "Name cannot be numbers only",
            }));
          }
        }
        break;

      case "email":
        setEmail(value);
        if (value.trim().length > 0) {
          if (!/^[a-zA-Z0-9\s@%&_\-,\.\(\)]+$/.test(value.trim())) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [fieldName]: "Email can only contain letters, numbers, spaces, and @ % & _ - , . ( )",
            }));
          } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value.trim())) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [fieldName]: "Please enter a valid email address",
            }));
          }
        }
        break;

      case "vendorMobile":
        const numericValue = value.replace(/\D/g, "");
        if (numericValue.length <= 10) {
          setVendorMobile(numericValue);
          if (numericValue.length > 0 && numericValue.length !== 10) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [fieldName]: "Mobile number must be exactly 10 digits",
            }));
          }
        }
        break;

      case "companyName":
        setCompanyName(value);
        if (value.trim().length > 0 && value.trim().length < 3) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: "Company name must be at least 3 characters",
          }));
        } else if (value.trim().length >= 3) {
          if (!/^[a-zA-Z0-9\s@%&_\-,\.\(\)]+$/.test(value.trim())) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [fieldName]: "Company name can only contain letters, numbers, spaces, and @ % & _ - , . ( )",
            }));
          } else if (/^\d+$/.test(value.trim())) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [fieldName]: "Company name cannot be numbers only",
            }));
          }
        }
        break;

      case "address":
        setAddress(value);
        if (value.trim().length > 0 && value.trim().length < 10) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: "Address must be at least 10 characters",
          }));
        } else if (value.trim().length >= 10) {
          if (!/^[a-zA-Z0-9\s@%&_\-,\.\(\)]+$/.test(value.trim())) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [fieldName]: "Address can only contain letters, numbers, spaces, and @ % & _ - , . ( )",
            }));
          } else if (/^\d+$/.test(value.trim())) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [fieldName]: "Address cannot be numbers only",
            }));
          }
        }
        break;
      case "vehicleNumber":
        setVehicleNumber(value.toUpperCase());
        break;

      case "vehicleTypeValue":
        setVehicleTypeValue(value);
        break;

      case "chassisNumber":
        setChassisNumber(value.toUpperCase());
        break;

      case "engineNumber":
        setEngineNumber(value.toUpperCase());
        break;

      case "weightLimit":
        const numericWeight = value.replace(/\D/g, "");
        setWeightLimit(numericWeight);
        break;

      case "officialName":
        setOfficialName(value);
        if (value.trim().length > 0 && value.trim().length < 3) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: "Official name must be at least 3 characters",
          }));
        } else if (value.trim().length >= 3) {
          if (!/^[a-zA-Z0-9\s@%&_\-,\.\(\)]+$/.test(value.trim())) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [fieldName]: "Official name can only contain letters, numbers, spaces, and @ % & _ - , . ( )",
            }));
          } else if (/^\d+$/.test(value.trim())) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [fieldName]: "Official name cannot be numbers only",
            }));
          }
        }
        break;
      default:
        break;
    }
  };

  const handleAlertOpen = () => setOpen(true);
  const handleAlertClose = () => setOpen(false);

  const removeImage = () => {
    if (isEditMode && fileView.includes("staging.watsoo.com")) {
      const fileName = fileView.split("=")[1];
      if (fileName) {
        DeleteFileAction.deleteFile(
          {
            fileName,
            type: "vendor",
            id: id,
          },
          showSnackbar,
        ).then((response) => {
          if (response != null) {
            fetchById();
          }
        });
      }
    }
    setFileView("");
    setFile(null);
    handleAlertClose();
  };

  const onFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onload = function (e) {
        setFileView(e.target.result);
        document.getElementById("showFile").value = "";
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const openFile = () => {
    document.getElementById("showFile").click();
  };

  const fetchVehicleList = () => {
    let sideIds = [];
    const userData = JSON.parse(sessionStorage.getItem("data"));
    if (userData?.sites?.length > 0) {
      userData.sites.forEach((element) => {
        sideIds.push(element.id);
      });
    }

    VehicleAction.fetchVehicleList2(
      {
        pageNo: 0,
        pageSize: 100,
        companyId: userData.companyId,
        number: "",
        vehicleType: "",
        driver: "",
        siteIds: sideIds,
        userId: userData.id,
        allVehicle: true,
        forDropDown: true,
      },
      showSnackbar,
    ).then((response) => {
      if (response != null) {
        setVehicleList(response?.data || []);
      } else {
        setVehicleList([]);
      }
    });
  };

  const fetchVehicleTypeList = () => {
    VehicleAction.vehicleTypeList(showSnackbar).then((response) => {
      if (response != null) {
        setVehicleTypeList(response);
      }
    });
  };

  const fetchById = () => {
    if (!isEditMode) return;

    setLoading(true);
    const userData = JSON.parse(sessionStorage.getItem("data"));
    const urlParams = new URLSearchParams(window.location.search);
    const nitIdFromUrl = urlParams.get("NitId") || "";

    VendorAction.fetchById(
      {
        userId: id,
        companyId: userData.companyId,
        user: userData.id,
        nitId: nitIdFromUrl,
      },
      showSnackbar,
    ).then((response) => {
      if (response != null) {
        setName(response.name || "");
        setEmail(response.email || "");
        setVendorMobile(response.phoneNumber || "");
        setMultiVehicles(response.vehicles || []);
        setCompanyName(response.companyName || "");
        setAddress(response.address || "");
        setOfficialName(response.officialName || "");

        if (response.image) {
          setFileView(`http://staging.watsoo.com/watsoo-vts${response.image}`);
        }
        if (Array.isArray(response.vendorTransactionDTO)) {
          const formattedTransactions = response.vendorTransactionDTO
            .map((t) => ({
              id: t.id,
              fromDate: t.fromTransactionDate
                ? t.fromTransactionDate.split("T")[0]
                : "",
              toDate: t.toTransactionDate
                ? t.toTransactionDate.split("T")[0]
                : "",
              isActive: t.isActive ?? true,
            }))
            .reverse(); // Reverse the array here

          setTransactions(formattedTransactions);
        } else {
          setTransactions([]);
        }
      }

      setLoading(false);
    });
  };

  const handleSubmit = () => {
    const formData = {
      name,
      officialName,
      email,
      vendorMobile,
      companyName,
      address,
      value,
      vehicleNumber,
      vehicleTypeValue,
      chassisNumber,
      engineNumber,
      weightLimit,
    };

    const validationErrors = validateVendorData(formData);
    setErrors(validationErrors);

    const hasValidationErrors = Object.keys(validationErrors).length > 0;
    if (hasValidationErrors) {
      showSnackbar(
        "Please fix the validation errors before submitting",
        "error",
      );
      return;
    }

    setLoading(true);
    const userData = JSON.parse(sessionStorage.getItem("data"));
    let data = new FormData();

    data.append("name", name);
    data.append("officialName", officialName);
    data.append("email", email);
    data.append("phoneNumber", vendorMobile);
    data.append("address", address);
    data.append("companyName", companyName);
    data.append("companyId", userData.companyId);

    if (file) {
      data.append("vendorImage", file);
    }

    if (isEditMode) {
      data.append("id", id);
      data.append("UpdatedBy", userData.id);
    } else {
      data.append("createdBy", userData.id);
    }

    if (value === "Existing") {
      multiVehicles.forEach((element, index) => {
        data.append(`vehicles[${index}].id`, element.id);
      });
    } else if (!isEditMode && (vehicleNumber || vehicleTypeValue)) {
      data.append("vehicles[0].number", vehicleNumber);
      data.append("vehicles[0].vehicleType.id", vehicleTypeValue.id);
      data.append("vehicles[0].chassisNumber", chassisNumber);
      data.append("vehicles[0].engineNumber", engineNumber);
      data.append("vehicles[0].weightLimit", weightLimit);
      data.append("vehicles[0].company.id", userData.companyId);
      data.append("vehicles[0].createdBy", userData.id);
    }
    const action = isEditMode ? VendorAction.updateUser : VendorAction.saveUser;

    action(data, showSnackbar).then((response) => {
      if (response != null) {
        const message = isEditMode
          ? "Updated Successfully"
          : "Transporter Created Successfully";
        showSnackbar(message, "success");
        navigate("/transporterlist");
      }
      setLoading(false);
    });
  };

  const goBack = () => {
    navigate("/transporterlist");
  };

  const removeVehicle = (module) => {
    const updated = multiVehicles.filter(
      (item) => item.number !== module.number,
    );
    setMultiVehicles(updated);
  };

  const fetchNitList = () => {
    NitMasterAction.fetchNitList({}, showSnackbar).then((response) => {
      if (response != null && response.data) {
        setNitList(response.data);
      } else {
        setNitList([]);
      }
    });
  };

  React.useEffect(() => {
    fetchVehicleTypeList();
    fetchVehicleList();
    // fetchNitList();
    if (isEditMode) {
      fetchById();
    }
  }, [isEditMode]);

  const topViewData = {
    title: isEditMode ? "Update Transporter" : "Add Transporter",
    subTitleFirst: "Dashboard >",
    subTitleSecond: "Transporter Management >",
    subTitleThird: isEditMode ? "Update Transporter" : "Add Transporter",
    buttonIcon: false,
    backPath: "/dashboard",
    backPathSecond: "/TransporterList",
    addButton: !isEditMode,
    addCancelClick: goBack,
    addClick: handleSubmit,
    updateButton: isEditMode,
    updateClick: handleSubmit,
    goBackEditClick: goBack,
    updatePermission: updateUserPermission,
    addButtonPermission: false,
    addPermission: updateUserPermission,
  };

  const handleAddTransaction = () => {
    if (!isEditMode) {
      showSnackbar(
        "Transactions can only be added after Transporter creation",
        "error",
      );
      return;
    }

    setNewTransaction({
      fromDate: null,
      toDate: null,
      isActive: true,
    });
    setEditingTransactionId(null);
    setTransactionModalOpen(true);
  };

  const handleCloseTransactionModal = () => {
    setTransactionModalOpen(false);
    setEditingTransactionId(null);
    setTransactionErrors({});
  };

  const handleTransactionFieldChange = (field, value) => {
    setTransactionErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
    setNewTransaction((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="makeStylesRoot">
      <LoadingComponent isLoading={isLoading} />
      <AlertDialog
        handleAlertOpen={handleAlertOpen}
        handleAlertClose={handleAlertClose}
        openAlert={openAlert}
        removeImage={removeImage}
      />

      <Container>
        <TopView data={topViewData} />

        <Paper className={classes.mainCard}>
          <div className={classes.formSection}>
            <Grid container spacing={3} className={classes.gridSpace}>
              <Grid item xs={9}>
                <Grid container spacing={3}>
                  <Grid item xs={4}>
                    <div style={{ marginBottom: 20 }}>
                      <Typography className={classes.label}>
                        <PersonIcon color="primary" />
                        Transporter Name <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        className={classes.modernTextField}
                        fullWidth
                        id="name"
                        type="text"
                        variant="outlined"
                        placeholder="Enter Name"
                        value={name}
                        error={!!errors.name}
                        helperText={errors.name || ""}
                        onChange={(event) =>
                          handleChange("name", event.target.value)
                        }
                      />
                    </div>

                    <div style={{ marginBottom: 20 }}>
                      <Typography className={classes.label}>
                        <BusinessIcon color="primary" />
                        Transporter Company Name{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        className={classes.modernTextField}
                        fullWidth
                        id="companyName"
                        type="text"
                        variant="outlined"
                        placeholder="Enter Company Name"
                        value={companyName}
                        error={!!errors.companyName}
                        helperText={errors.companyName || ""}
                        onChange={(event) =>
                          handleChange("companyName", event.target.value)
                        }
                      />
                    </div>
                  </Grid>

                  <Grid item xs={4}>
                    <div style={{ marginBottom: 20 }}>
                      <Typography className={classes.label}>
                        <PhoneIcon color="primary" />
                        Transporter Mobile Number{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        className={classes.modernTextField}
                        fullWidth
                        id="vendorMobile"
                        type="text"
                        variant="outlined"
                        placeholder="Enter Mobile Number"
                        value={vendorMobile}
                        error={!!errors.vendorMobile}
                        helperText={errors.vendorMobile || ""}
                        inputProps={{ maxLength: 10 }}
                        onChange={(event) =>
                          handleChange("vendorMobile", event.target.value)
                        }
                        InputProps={{
                          startAdornment: (
                            <Typography
                              style={{
                                marginRight: 8,
                                fontWeight: 500,
                              }}
                            >
                              +91
                            </Typography>
                          ),
                        }}
                      />
                    </div>

                    <div style={{ marginBottom: 20 }}>
                      <Typography className={classes.label}>
                        <LocationIcon color="primary" />
                        Transporter Address{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        className={classes.modernTextField}
                        fullWidth
                        id="address"
                        type="text"
                        variant="outlined"
                        placeholder="Enter Address"
                        value={address}
                        error={!!errors.address}
                        helperText={errors.address || ""}
                        onChange={(event) =>
                          handleChange("address", event.target.value)
                        }
                      />
                    </div>
                  </Grid>

                  <Grid item xs={4}>
                    <div style={{ marginBottom: 20 }}>
                      <Typography className={classes.label}>
                        <EmailIcon color="primary" />
                        Transporter Email ID{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        className={classes.modernTextField}
                        fullWidth
                        id="email"
                        type="email"
                        variant="outlined"
                        placeholder="Enter Email"
                        value={email}
                        error={!!errors.email}
                        helperText={errors.email || ""}
                        onChange={(event) =>
                          handleChange("email", event.target.value)
                        }
                      />
                    </div>{" "}
                    <div style={{ marginBottom: 20 }}>
                      <Typography className={classes.label}>
                        <PersonIcon color="primary" />
                        Transporter Official Name{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        className={classes.modernTextField}
                        fullWidth
                        id="officialName"
                        type="text"
                        variant="outlined"
                        placeholder="Enter Official Name"
                        value={officialName}
                        error={!!errors.officialName}
                        helperText={errors.officialName || ""}
                        onChange={(event) =>
                          handleChange("officialName", event.target.value)
                        }
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>

          <div className={classes.sectionDivider}></div>

          <div className={classes.formSection}>
            <Typography className="ml-1 pt-1" gutterBottom variant="h6">
              <span className="fontbold">
                <CarIcon color="primary" style={{ marginRight: 8 }} />
                Assign Vehicles
              </span>
            </Typography>

            <div>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <Autocomplete
                    multiple
                    id="vehicle-selector"
                    limitTags={2}
                    getOptionLabel={(vehicle) => vehicle.number}
                    className={classes.modernAutocomplete}
                    options={vehicleList}
                    filterSelectedOptions
                    disablePortal={true}
                    getOptionSelected={(option, value) =>
                      option.number === value.number
                    }
                    value={multiVehicles}
                    disableClearable
                    onChange={(event, newValue) => setMultiVehicles(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        margin="dense"
                        placeholder="Select Vehicles"
                      />
                    )}
                  />
                </Grid>
                {/* <Grid item xs={6}>
                  <Autocomplete
                    id="nit-selector"
                    options={nitList || []}
                    getOptionLabel={(option) => option.nitNumber || ""}
                    getOptionSelected={(option, value) =>
                      option.id === value.id
                    }
                    value={selectedNit}
                    onChange={(event, newValue) => setSelectedNit(newValue)}
                    className={classes.modernAutocomplete}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        margin="dense"
                        placeholder="Select NIT"
                      />
                    )}
                  />
                </Grid> */}
              </Grid>
            </div>

            {multiVehicles?.length > 0 && (
              <Box
                style={{
                  background:
                    "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
                  border: "1px solid #bae6fd",
                  borderRadius: "16px",
                  padding: "16px",
                  margin: "16px 0",
                }}
              >
                <Typography
                  variant="subtitle2"
                  style={{
                    marginBottom: 12,
                    color: "#0369a1",
                    fontWeight: 600,
                  }}
                >
                  Selected Vehicles ({multiVehicles.length})
                </Typography>
                {multiVehicles.map((module) => (
                  <Chip
                    key={module.number}
                    label={module.number}
                    size="small"
                    variant="outlined"
                    className={localStyles.statusChip}
                    onDelete={() => removeVehicle(module)}
                    style={{ margin: "4px" }}
                  />
                ))}
              </Box>
            )}
          </div>

          {isEditMode && (
            <>
              <div className={classes.sectionDivider}></div>
              <div className={classes.formSection}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 24,
                  }}
                >
                  <span
                    className="fontbold"
                    style={{ display: "flex", gap: "10px" }}
                  >
                    <CarIcon color="primary" />
                    Transaction Sequence
                  </span>

                  {JSON.parse(sessionStorage.getItem("data"))?.userType ===
                    "ADMIN" && (
                    <Button
                      className={localStyles.addButton}
                      size="small"
                      onClick={handleAddTransaction}
                      startIcon={<span style={{ fontSize: "1.2rem" }}>+</span>}
                    >
                      Add Transaction
                    </Button>
                  )}
                </div>

                <Box className={localStyles.sectionContainer}>
                  <TableContainer className={localStyles.tableContainer}>
                    <Table size="small">
                      <TableHead className={localStyles.tableHead}>
                        <TableRow>
                          <TableCell>
                            <strong>S.No</strong>
                          </TableCell>
                          <TableCell>
                            <strong>From Date</strong>
                          </TableCell>
                          <TableCell>
                            <strong>To Date</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Status</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {transactions
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage,
                          )
                          .map((row, index) => (
                            <TableRow
                              key={row.id}
                              className={localStyles.tableRow}
                            >
                              <TableCell>
                                <Typography
                                  variant="subtitle1"
                                  style={{
                                    fontWeight: 600,
                                    color: "#374151",
                                    background:
                                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                  }}
                                >
                                  {page * rowsPerPage + index + 1}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography
                                  style={{
                                    color: "#374151",
                                    fontWeight: 500,
                                  }}
                                >
                                  {row.fromDate
                                    ? moment(row.fromDate).format("DD-MM-YYYY")
                                    : ""}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography
                                  style={{
                                    color: "#374151",
                                    fontWeight: 500,
                                  }}
                                >
                                  {row.toDate
                                    ? moment(row.toDate).format("DD-MM-YYYY")
                                    : ""}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Chip
                                  label={row.isActive ? "Active" : "Inactive"}
                                  size="small"
                                  className={`${localStyles.transactionChip} ${
                                    row.isActive
                                      ? localStyles.transactionActiveChip
                                      : localStyles.transactionInactiveChip
                                  }`}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        {transactions.length === 0 && (
                          <TableRow>
                            <TableCell colSpan={4}>
                              <Box className={localStyles.emptyState}>
                                <Typography
                                  variant="h6"
                                  style={{
                                    background:
                                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    fontWeight: 600,
                                  }}
                                >
                                  No Transactions Yet
                                </Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {transactions.length > 0 && (
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={transactions.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      className={localStyles.pagination}
                      labelRowsPerPage="Rows per page:"
                      labelDisplayedRows={({ from, to, count }) =>
                        `Showing ${from}-${to} of ${count}`
                      }
                    />
                  )}
                </Box>
              </div>
            </>
          )}

          <input
            type="file"
            id="showFile"
            style={{ display: "none" }}
            onChange={onFileChange}
            accept="image/*"
          />
        </Paper>
      </Container>

      <Dialog
        open={transactionModalOpen}
        onClose={handleCloseTransactionModal}
        maxWidth="sm"
        fullWidth
        className={localStyles.transactionModal}
      >
        <DialogTitle className={localStyles.modalTitle}>
          <Typography
            variant="h6"
            style={{ display: "flex", alignItems: "center" }}
          >
            <CarIcon style={{ marginRight: 8 }} />
            {editingTransactionId ? "Edit Transaction" : "Add New Transaction"}
          </Typography>
        </DialogTitle>

        <DialogContent className={localStyles.modalContent}>
          <Grid container spacing={3} style={{ marginTop: 8 }}>
            <Grid item xs={12}>
              <Typography className={classes.label}>
                From Date <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                className={classes.modernTextField}
                fullWidth
                type="date"
                variant="outlined"
                value={
                  newTransaction.fromDate
                    ? newTransaction.fromDate.toISOString().split("T")[0]
                    : ""
                }
                error={!!transactionErrors.fromDate}
                helperText={transactionErrors.fromDate || ""}
                onChange={(event) =>
                  handleTransactionFieldChange(
                    "fromDate",
                    new Date(event.target.value),
                  )
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography className={classes.label}>
                To Date <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                className={classes.modernTextField}
                fullWidth
                type="date"
                variant="outlined"
                value={
                  newTransaction.toDate
                    ? newTransaction.toDate.toISOString().split("T")[0]
                    : ""
                }
                error={!!transactionErrors.toDate}
                helperText={transactionErrors.toDate || ""}
                onChange={(event) =>
                  handleTransactionFieldChange(
                    "toDate",
                    new Date(event.target.value),
                  )
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={newTransaction.isActive}
                    onChange={(event) =>
                      handleTransactionFieldChange(
                        "isActive",
                        event.target.checked,
                      )
                    }
                    color="primary"
                  />
                }
                label="Active Transaction"
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions
          style={{
            padding: 15,
            borderTop: "1px solid rgba(102, 126, 234, 0.1)",
            background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
          }}
        >
          <Button
            onClick={handleCloseTransactionModal}
            className={`${classes.dialogButton} ${classes.cancelButton}`}
            // style={{ backgroundColor: "red" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveTransaction}
            className={`${classes.dialogButton} ${classes.submitButton}`}
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            }}
          >
            {editingTransactionId ? "Update Transaction" : "Save Transaction"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
